import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import injectSaga from 'utils/injectSaga';
import landingSaga from 'containers/Landing/saga';
import { LANDING_PAGE_KEY } from 'containers/Landing/constants';
import { fetchPageRequest } from 'containers/Landing/actions';
import { selectLandingData } from 'containers/Landing/selectors';
import { selectIsFetching } from 'containers/Authentication/selectors';

import { CART_PAGE_KEY } from './constants';
import {
  createCart,
  loadCartProducts,
  removeItem,
  changeItemQuantity,
} from './actions';
import saga from './saga';
import {
  selectCartData,
  selectCartLoading,
  selectCartSummary,
  selectCartIsLoaded,
  selectCartProductsLoading,
  selectSummaryLoading,
} from './selectors';
import Cart from './Cart';

const mapDispatchToProps = {
  fetchPage: fetchPageRequest,
  createCart,
  loadCartProducts,
  removeItem,
  changeItemQuantity,
};

const mapStateToProps = createStructuredSelector({
  site: selectLandingData(),
  cart: selectCartData(),
  cartSummary: selectCartSummary(),
  authenticationLoading: selectIsFetching(),
  cartLoading: selectCartLoading(),
  cartInitiated: selectCartIsLoaded(),
  cartProductsLoading: selectCartProductsLoading(),
  cartSummaryLoading: selectSummaryLoading(),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withLandingSaga = injectSaga({
  key: LANDING_PAGE_KEY,
  saga: landingSaga,
});
const withSaga = injectSaga({ key: CART_PAGE_KEY, saga });

export default compose(withConnect, withLandingSaga, withSaga)(Cart);
